import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import CheckBoxFilter from "../../../CheckBoxFilter"

export function SearchOperationFilter(
  {
    auth,
    filterState,
    setFilteredOperation,
    getFilteredOperation
  }) {

  const operations = [
    {
      label: auth?.user?.mainGroup === 'transporter' ? 'COM troca de notas (FBZ)' : 'FBZ',
      value: 'FBZ',
    },
    {
      label: auth?.user?.mainGroup === 'transporter' ? 'SEM troca de notas (FOB)' : 'FOB',
      value: 'FOB',
    }
  ];

  useEffect(() => {
    getFilteredOperation();
 }, [getFilteredOperation])

  return (
    <CheckBoxFilter
      label="Selecionar a Operação"
      onChange={(value) => {
        (value.target.checked)
          ?
            setFilteredOperation([
              ...filterState,
              {
                label: value.target.name,
                value: value.target.name
              }
            ])
          :
            setFilteredOperation([
              ...filterState.filter(item => item?.value !== value?.target?.name)
            ]);
      }}
      options={operations}
      value={filterState}
      width='100%'
    />
  );
}

SearchOperationFilter.propTypes = {
  className: PropTypes.string,
  setFilteredOperation: PropTypes.func.isRequired,
};

const mapState = ({ loadingOrders: { filterState }, auth }) => ({
  filterState,
  auth
});

const mapDispatch = (dispatch) => ({
  setFilteredOperation: (operation) => dispatch.loadingOrders.setFiltered(operation),
  getFilteredOperation: () => dispatch.loadingOrders.loadFiltered(),
});

export default connect(mapState, mapDispatch)(SearchOperationFilter);
